/* eslint-disable no-plusplus */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/button-has-type */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Overlay } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  MdOutlineSwapHoriz,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdOutlineCancel,
  MdAddCircleOutline,
  MdOutlineRemoveCircleOutline,
} from 'react-icons/md';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import './ModifySearch.scss';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppAsyncSelect from '../../shared/components/app-async-select/AppAsyncSelect';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import { getAirportsApi, getRecentAirports } from '../../api/flightApi';
import { mobileCheck, debounce } from '../../api/apiUtils';
import {
  API_DATE_FORMAT,
  NAVIGATION_ROUTES,
  TODAY_DATE,
  YEAR_MONTH_DATE_WITHOUT_SEPERATION,
} from '../../shared/constants/Constants';
import {
  formatDate,
  isSameDate,
  isAfterDate,
  isMobileWidth,
  getNewDate,
} from '../../shared/helper-utils/appUtils';
import AppButton from '../../shared/components/app-button/AppButton';
import AppLink from '../../shared/components/app-link/AppLink';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import { getAirportNameByCode } from '../../shared/constants/AirportsName';
import { useAppContext } from '../../saas/AppConfigWrapper';

const DEBOUNCE_DELAY = 500;

export const PREF_CLASS_DICT = {
  Y: 'economy',
  W: 'premium_economy',
  C: 'business',
  F: 'first_class',
};

const PREF_AIRLINE_OPTIONS = [
  { label: 'All Airlines', value: 'All' },
  { label: 'Air India(AI)', value: 'AI' },
  { label: 'Akasa Air(QP)', value: 'QP' },
  { label: 'Indigo(6E)', value: '6E' },
  { label: 'Air Asia(I5)', value: 'I5' },
  { label: 'Vistara(UK)', value: 'UK' },
  { label: 'Spice Jet(SG)', value: 'SG' },
  { label: 'Go Airlines(G8)', value: 'G8' },
  { label: 'Fly Big(S9)', value: 'S9' },
  { label: 'Alliance Air(9I)', value: '9I' },
  { label: 'Star Air(S5)', value: 'S5' },
  { label: 'AIr India Express(IX)', value: 'IX' },
  { label: 'GDS Carriers only(GDS)', value: 'GDS' },
];

const NUMPAX_DICT = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export function AirportOption(props) {
  return (
    <div
      onClick={() => props.selectOption(props.data)}
      className={`${props.isFocused ? 'airport-focused' : ''} airport-option`}
      key={props.value}
    >
      <div className="d-flex justify-content-between p-1">
        <div className="airport-city-details">
          <div className="fs-14 d-flex align-items-center">
            <span className="airport-option_country-code">
              {props.data.AirportCode}
            </span>
            <span className="black-color">
              {props.data.AirportLocation.split(',')[0]}
            </span>
          </div>
          <div className="airport-option_airport-name">
            {getAirportNameByCode(props.data.AirportCode)}
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end fs-12 airport-country-details gap-1">
          <span className="black-color">{props.data.Country}</span>
          <img
            src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${props.data.CountryCode.toLowerCase()}.svg`}
          />
        </div>
      </div>
    </div>
  );
}

function ModifySearch({
  previousSearchRequest,
  isModifySearch,
  onModifySearch,
}) {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const intl = useIntl();
  const [errors, setErrors] = useState({
    origin: '',
    destination: '',
    onwarddate: '',
    returndate: '',
    multiCity: [
      {
        origin: '',
        destination: '',
        onwarddate: '',
      },
      {
        origin: '',
        destination: '',
        onwarddate: '',
      },
    ],
  });
  const isApiRequestProcessingRef = useRef(false);
  const [defaultAirportsList, setDefaultAirportsList] = useState([]);
  const originAirportRef = useRef(null);
  const destinationAirportRef = useRef(null);
  const passengersOverlayTarget = useRef(null);
  const [openPassengers, setOpenPassengers] = useState(false);
  const isMobileView = useRef(false);
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [search, setSearch] = useState({
    flightsearchrequest: {
      origin: '',
      destination: '',
      onwarddate: getNewDate(TODAY_DATE),
      returndate: '',
      numadults: '1',
      numchildren: '0',
      numinfants: '0',
      journeytype: 'OneWay',
      prefclass: 'Y',
      requestformat: 'JSON',
      resultformat: 'JSON',
      searchtype: 'normal',
      sortkey: '',
      issbt: 'false',
      profileid: '',
      numresults: 100,
      actionname: 'FLIGHTSEARCH',
      preddeptimewindow: null,
      prefarrtimewindow: null,
      prefcarrier: 'All',
      excludecarriers: '',
      refundtype: 'All',
      layovertime: '',
      promocode: '',
      nonstopsearch: 'false',
      multiCitySearch: [
        {
          origin: '',
          destination: '',
          onwarddate: getNewDate(TODAY_DATE),
          selectedOrigin: '',
          selectedDestination: '',
        },
        {
          origin: '',
          destination: '',
          onwarddate: '',
          selectedOrigin: '',
          selectedDestination: '',
        },
      ],
    },
  });

  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  const getLabel = (label, code) => {
    return isMobileWidth() ? (
      <div className="d-flex flex-column white-color">
        <span style={{ fontSize: '14px', fontWeight: '600' }}>{label}</span>
        <span
          style={{
            fontSize: '10px',
            fontWeight: '400',
            marginTop: '-4px',
          }}
        >
          {code}
        </span>
      </div>
    ) : (
      <div className="d-flex flex-column">
        <span style={{ fontSize: '14px', fontWeight: '600', color: '#fff' }}>
          {label} - {code}
        </span>
      </div>
    );
  };

  const getDateFormat = (date) => {
    return `${date.substring(0, 4)}-${date.substring(4, 6)}-${date.substring(
      6,
      8,
    )}`;
  };

  useEffect(() => {
    if (
      previousSearchRequest &&
      Object.keys(previousSearchRequest).length > 0
    ) {
      if (previousSearchRequest.journeytype !== 'MultiCity') {
        originAirportRef.current = {
          label: getLabel(
            previousSearchRequest.originLocation.split(',')[0],
            previousSearchRequest.origin,
          ),
          AirportLocation: previousSearchRequest.originLocation,
          value: previousSearchRequest.origin,
          Country: previousSearchRequest.originLocation.split(',').pop().trim(),
        };
        destinationAirportRef.current = {
          label: getLabel(
            previousSearchRequest.destinationLocation.split(',')[0],
            previousSearchRequest.destination,
          ),
          AirportLocation: previousSearchRequest.destinationLocation,
          value: previousSearchRequest.destination,
          Country: previousSearchRequest.destinationLocation
            .split(',')
            .pop()
            .trim(),
        };
        setSearch((prevState) => ({
          ...prevState,
          flightsearchrequest: {
            ...prevState.flightsearchrequest,
            origin: previousSearchRequest.origin,
            destination: previousSearchRequest.destination,
            numadults: previousSearchRequest.numadults,
            numchildren: previousSearchRequest.numchildren,
            numinfants: previousSearchRequest.numinfants,
            journeytype: previousSearchRequest.journeytype,
            returndate:
              previousSearchRequest.returndate !== undefined
                ? getNewDate(previousSearchRequest.returndate)
                : '',
            searchtype: previousSearchRequest.searchtype,
            onwarddate: getNewDate(previousSearchRequest.onwarddate),
            promocode: previousSearchRequest.promocode,
            prefclass: previousSearchRequest.prefclass,
            prefcarrier: previousSearchRequest.prefcarrier,
            nonstopsearch: previousSearchRequest.nonstopsearch,
          },
        }));
      } else {
        const originArr = previousSearchRequest.origin.split(':');
        const destinationArr = previousSearchRequest.destination.split(':');
        const onwarddateArr = previousSearchRequest.onwarddate.split(':');
        const originLocationArr =
          previousSearchRequest.originlocations.split(':');
        const destinationLocationArr =
          previousSearchRequest.destinationlocations.split(':');
        const multiSearch = new Array(Number(previousSearchRequest.numsectors))
          .fill(0)
          .map((d, index) => ({
            origin: originArr[index],
            destination: destinationArr[index],
            onwarddate: getNewDate(getDateFormat(onwarddateArr[index])),
            selectedOrigin: {
              label: getLabel(
                originLocationArr[index].split(',')[0],
                originArr[index],
              ),
              AirportLocation: originLocationArr[index],
              value: originArr[index],
              Country: originLocationArr[index].split(',').pop().trim(),
            },
            selectedDestination: {
              label: getLabel(
                destinationLocationArr[index].split(',')[0],
                destinationArr[index],
              ),
              AirportLocation: destinationLocationArr[index],
              value: destinationArr[index],
              Country: destinationLocationArr[index].split(',').pop().trim(),
            },
          }));
        originAirportRef.current = null;
        destinationAirportRef.current = null;
        const errorList = new Array(Number(previousSearchRequest.numsectors))
          .fill(0)
          .map((d, index) => ({
            origin: '',
            destination: '',
            onwarddate: '',
          }));
        setErrors({ ...errors, multiCity: errorList });
        setSearch((prevState) => ({
          ...prevState,
          flightsearchrequest: {
            ...prevState.flightsearchrequest,
            numadults: previousSearchRequest.numadults,
            numchildren: previousSearchRequest.numchildren,
            numinfants: previousSearchRequest.numinfants,
            journeytype: previousSearchRequest.journeytype,
            searchtype: previousSearchRequest.searchtype,
            prefclass: previousSearchRequest.prefclass,
            onwarddate: getNewDate(TODAY_DATE),
            multiCitySearch: multiSearch,
          },
        }));
      }
    }
  }, [previousSearchRequest]);

  const handleUpdateSearchState = (name, value) => {
    if (
      search.flightsearchrequest.searchtype === 'seniorcitizen' ||
      search.flightsearchrequest.searchtype === 'student'
    ) {
      if (name === 'numchildren' || name === 'numinfants') {
        setAlert({
          title: 'Flight Search',
          description: 'Children and Infants are not allowed for this booking',
          variant: 'error',
        });
        return false;
      }
    }
    if (name === 'searchtype' && value !== 'normal') {
      setSearch((prev) => ({
        ...prev,
        flightsearchrequest: {
          ...prev.flightsearchrequest,
          numchildren: '0',
          numinfants: '0',
        },
      }));
    }
    setSearch((prevState) => ({
      ...prevState,
      flightsearchrequest: {
        ...prevState.flightsearchrequest,
        [name]: value,
      },
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const getDefaultAirports = async () => {
    if (!isApiRequestProcessingRef.current) {
      isApiRequestProcessingRef.current = true;
      const response = await getRecentAirports();
      if (
        response &&
        response.ApiStatus &&
        response.ApiStatus.Status === 'OK'
      ) {
        const { Result } = response.ApiStatus;
        let { AirportDetail } = Result;
        AirportDetail = Array.isArray(AirportDetail)
          ? AirportDetail
          : [AirportDetail];
        AirportDetail.forEach((airport) => {
          airport.label = getLabel(
            airport.AirportLocation.split(',')[0],
            airport.AirportCode,
          );
          airport.value = airport.AirportCode;
        });
        setDefaultAirportsList(AirportDetail);
        if (
          originAirportRef.current === null &&
          destinationAirportRef.current === null &&
          previousSearchRequest === undefined
        ) {
          [originAirportRef.current, destinationAirportRef.current] =
            AirportDetail;
          handleUpdateSearchState(
            'origin',
            originAirportRef.current.AirportCode,
          );
          handleUpdateSearchState(
            'destination',
            destinationAirportRef.current.AirportCode,
          );
          setSearch((prevState) => ({
            ...prevState,
            flightsearchrequest: {
              ...prevState.flightsearchrequest,
              multiCitySearch: [
                {
                  origin: AirportDetail[0].AirportCode,
                  destination: AirportDetail[1].AirportCode,
                  onwarddate: getNewDate(TODAY_DATE),
                  selectedOrigin: AirportDetail[0],
                  selectedDestination: AirportDetail[1],
                },
                {
                  origin: AirportDetail[1].AirportCode,
                  destination: '',
                  onwarddate: '',
                  selectedOrigin: AirportDetail[1],
                  selectedDestination: '',
                },
              ],
            },
          }));
        }
      }
    }
  };

  useEffect(() => {
    isMobileView.current = mobileCheck();
    getDefaultAirports();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'journeytype' && value === 'OneWay') {
      handleUpdateSearchState('returndate', '');
    }
    handleUpdateSearchState(name, value);
  };

  const handleClearReturnDate = () => {
    setSearch((prevState) => ({
      ...prevState,
      flightsearchrequest: {
        ...prevState.flightsearchrequest,
        returndate: '',
        journeytype: 'OneWay',
      },
    }));
  };

  const loadAirportSuggestions = debounce(async (query, callback) => {
    let airports = [];
    if (query.length >= 3) {
      const response = await getAirportsApi(query);
      airports = response.map((airportNode) => ({
        label: getLabel(
          airportNode.AirportLocation.split(',')[0],
          airportNode.AirportCode,
        ),
        value: airportNode.AirportCode,
        ...airportNode,
      }));
    }
    callback(airports);
  }, DEBOUNCE_DELAY);

  const handleAirportSelect = (airport, name) => {
    if (name === 'origin') {
      originAirportRef.current = airport;
      let originAirportCode = '';
      if (airport !== null) {
        originAirportCode = airport.value;
      }
      handleUpdateSearchState('origin', originAirportCode);
    } else {
      destinationAirportRef.current = airport;
      let destinationAirportCode = '';
      if (airport !== null) {
        destinationAirportCode = airport.value;
      }
      handleUpdateSearchState('destination', destinationAirportCode);
    }
  };

  const handleSwap = () => {
    const tempOrigin = search.flightsearchrequest.origin;
    const tempOriginDetail = originAirportRef.current;

    handleUpdateSearchState('origin', search.flightsearchrequest.destination);
    handleUpdateSearchState('destination', tempOrigin);
    originAirportRef.current = destinationAirportRef.current;
    destinationAirportRef.current = tempOriginDetail;
  };

  const handleDateChange = (date, fieldName) => {
    if (fieldName === 'returndate') {
      handleUpdateSearchState('journeytype', 'RoundTrip');
    }
    handleUpdateSearchState(fieldName, date);
  };

  const handlePassengersSelection = () => {
    setOpenPassengers(false);
  };

  const handleFlightSearch = (event) => {
    let isErrorExist = false;
    const errorsObj = {
      origin: '',
      destination: '',
      onwarddate: '',
      returndate: '',
      multiCity: [],
    };
    const searchRequest = { ...search.flightsearchrequest };
    if (searchRequest.numinfants > searchRequest.numadults) {
      setAlert({
        title: 'Flight Search',
        description: 'Number of infants cannot be more than adults',
        variant: 'error',
      });
      return false;
    }
    if (event.target.name === 'searchtype') {
      searchRequest.searchtype = event.target.value;
    }
    if (
      searchRequest.searchtype === 'seniorcitizen' ||
      searchRequest.searchtype === 'student'
    ) {
      if (
        parseInt(searchRequest.numinfants, 10) > 0 ||
        parseInt(searchRequest.numchildren, 10) > 0
      ) {
        setAlert({
          title: 'Flight Search',
          description: 'Children and Infants are not allowed for this booking',
          variant: 'error',
        });
        return false;
      }
    }

    if (searchRequest.journeytype !== 'MultiCity') {
      if (searchRequest.origin === '') {
        errorsObj.origin = formattedMessage('origin_validation');
        isErrorExist = true;
      }
      if (searchRequest.destination === '') {
        errorsObj.destination = formattedMessage('destination_validation');
        isErrorExist = true;
      }
      if (
        searchRequest.origin &&
        searchRequest.origin === searchRequest.destination
      ) {
        errorsObj.destination = formattedMessage(
          'same_origin_destination_validation',
        );
        isErrorExist = true;
      }
      if (
        searchRequest.onwarddate === null ||
        searchRequest.onwarddate === undefined ||
        searchRequest.onwarddate === ''
      ) {
        errorsObj.onwarddate = formattedMessage('onward_date_validation');
        isErrorExist = true;
      }
      if (
        searchRequest.journeytype === 'RoundTrip' &&
        (searchRequest.returndate === null ||
          searchRequest.returndate === undefined ||
          searchRequest.returndate === '')
      ) {
        errorsObj.returndate = formattedMessage('return_date_validation');
        isErrorExist = true;
      }

      searchRequest.onwarddate = formatDate(
        searchRequest.onwarddate,
        API_DATE_FORMAT,
      );
      if (
        searchRequest.returndate !== '' &&
        searchRequest.returndate !== undefined
      ) {
        searchRequest.returndate = formatDate(
          searchRequest.returndate,
          API_DATE_FORMAT,
        );
        if (
          !isSameDate(
            getNewDate(searchRequest.onwarddate),
            getNewDate(searchRequest.returndate),
          ) &&
          isAfterDate(
            getNewDate(searchRequest.onwarddate),
            getNewDate(searchRequest.returndate),
          )
        ) {
          errorsObj.onwaredDateAfterReturnDate = formattedMessage(
            'return_onward_date_validation',
          );
          isErrorExist = true;
        }
      } else {
        searchRequest.returndate = null;
      }
    } else {
      searchRequest.multiCitySearch.forEach((d, index) => {
        const error = {};
        if (d.origin === '') {
          error.origin = 'Please select origin.';
          isErrorExist = true;
        }
        if (
          d.destination === '' ||
          d.destination === undefined ||
          d.destination === null
        ) {
          error.destination = 'Please select destination.';
          isErrorExist = true;
        }
        if (d.origin && d.origin === d.destination) {
          error.destination = 'Origin and Destination cant be same.';
          isErrorExist = true;
        }
        if (
          d.onwarddate === null ||
          d.onwarddate === undefined ||
          d.onwarddate === ''
        ) {
          error.onwarddate = 'Select journey date.';
          isErrorExist = true;
        }
        if (index !== 0) {
          if (
            d.onwarddate !== null &&
            d.onwarddate !== undefined &&
            d.onwarddate !== '' &&
            searchRequest.multiCitySearch[index - 1].onwarddate.onwarddate !==
              null &&
            searchRequest.multiCitySearch[index - 1].onwarddate.onwarddate !==
              undefined &&
            searchRequest.multiCitySearch[index - 1].onwarddate.onwarddate !==
              ''
          )
            if (
              isAfterDate(
                getNewDate(searchRequest.multiCitySearch[index - 1].onwarddate),
                getNewDate(d.onwarddate),
              )
            ) {
              error.onwarddate = 'Date is less than previous journey';
              isErrorExist = true;
            }
        }
        errorsObj.multiCity.push(error);
      });
    }
    setErrors(errorsObj);
    if (isErrorExist) {
      return true;
    }
    if (searchRequest.journeytype === 'MultiCity') {
      if (
        searchRequest.searchtype !== 'normal' &&
        searchRequest.searchtype !== 'seriesfares'
      ) {
        setAlert({
          title: 'Flight Search',
          variant: 'error',
          description:
            'Multi City search is only available for normal search type',
        });
        return false;
      }
      const originArr = [];
      const destinationArr = [];
      const dateArr = [];
      const originLocationsArr = [];
      const destinationLocationsArr = [];
      let isIntlSearch = false;
      searchRequest.multiCitySearch.forEach((sector) => {
        originArr.push(sector.origin);
        destinationArr.push(sector.destination);
        const formattedDate = formatDate(
          getNewDate(sector.onwarddate),
          YEAR_MONTH_DATE_WITHOUT_SEPERATION,
        );
        dateArr.push(formattedDate);
        originLocationsArr.push(sector.selectedOrigin.AirportLocation);
        destinationLocationsArr.push(
          sector.selectedDestination.AirportLocation,
        );
        if (
          (sector.selectedOrigin.Country !== '' &&
            sector.selectedOrigin.Country.toLowerCase() !== 'india') ||
          (sector.selectedDestination.Country !== '' &&
            sector.selectedDestination.Country.toLowerCase() !== 'india')
        ) {
          isIntlSearch = true;
        }
      });
      const numsectors = searchRequest.multiCitySearch.length;
      const queryParam = `origin=${originArr.join(
        ':',
      )}&destination=${destinationArr.join(':')}&onwarddate=${dateArr.join(
        ':',
      )}&numadults=${searchRequest.numadults}&numchildren=${
        searchRequest.numchildren
      }&numinfants=${
        searchRequest.numinfants
      }&originlocations=${originLocationsArr.join(':')}&prefclass=${
        searchRequest.prefclass
      }&journeytype=${searchRequest.journeytype}&searchtype=${
        searchRequest.searchtype
      }&promocode=${
        searchRequest.promocode
      }&destinationlocations=${destinationLocationsArr.join(
        ':',
      )}&numsectors=${numsectors}`;
      if (isIntlSearch) {
        navigate(
          `${NAVIGATION_ROUTES.FLIGHT.INTL_MULTICITY_RESULTS_ROUTE}?${queryParam}`,
        );
        return;
        // }
        // setAlert({
        //   title: 'Multi City Search',
        //   description: 'only domestic multicity search is allowed',
        //   variant: 'error',
        // });
        // return;
      }
      navigate(
        `${NAVIGATION_ROUTES.FLIGHT.DOM_MULTICITY_RESULTS_ROUTE}?${queryParam}`,
      );
      return;
    }
    // if (
    //   searchRequest.searchtype !== 'normal' &&
    //   searchRequest.searchtype !== 'seriesfares'
    // ) {
    //   if (
    //     (originAirportRef.current.Country !== '' &&
    //       originAirportRef.current.Country.toLowerCase() !== 'india') ||
    //     (destinationAirportRef.current.Country !== '' &&
    //       destinationAirportRef.current.Country.toLowerCase() !== 'india')
    //   ) {
    //     return;
    //   }
    // }
    let queryParam = `origin=${searchRequest.origin}&originLocation=${originAirportRef.current.AirportLocation}&destination=${searchRequest.destination}&destinationLocation=${destinationAirportRef.current.AirportLocation}&onwarddate=${searchRequest.onwarddate}`;
    if (searchRequest.returndate !== null) {
      queryParam += `&returndate=${searchRequest.returndate}`;
    }
    let dpt = '';
    if (
      searchRequest.preddeptimewindow !== null &&
      searchRequest.preddeptimewindow !== ''
    ) {
      dpt = searchRequest.preddeptimewindow.value
        ? searchRequest.preddeptimewindow.value
        : searchRequest.preddeptimewindow;
    }
    queryParam += `&numadults=${searchRequest.numadults}&numchildren=${searchRequest.numchildren}&numinfants=${searchRequest.numinfants}&prefclass=${searchRequest.prefclass}&prefcarrier=${searchRequest.prefcarrier}&journeytype=${searchRequest.journeytype}&preddeptimewindow=${dpt}&searchtype=${searchRequest.searchtype}&promocode=${searchRequest.promocode}&nonstopsearch=${searchRequest.nonstopsearch}`;
    if (searchRequest.journeytype === 'OneWay') {
      if (isModifySearch) {
        onModifySearch();
      }
      navigate(
        `${NAVIGATION_ROUTES.FLIGHT.ONE_WAY_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
      );
    } else if (
      (originAirportRef.current.Country !== '' &&
        originAirportRef.current.Country.toLowerCase() !== 'india') ||
      (destinationAirportRef.current.Country !== '' &&
        destinationAirportRef.current.Country.toLowerCase() !== 'india')
    ) {
      navigate(
        `${NAVIGATION_ROUTES.FLIGHT.INTERNATIONAL_ROUND_TRIP_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
      );
    } else {
      navigate(
        `${NAVIGATION_ROUTES.FLIGHT.ROUND_TRIP_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
      );
    }
  };

  const handleSearchTypeChange = (event) => {
    const { name, value } = event.target;
    setSearch((prevState) => ({
      ...prevState,
      flightsearchrequest: {
        ...prevState.flightsearchrequest,
        [name]: value,
      },
    }));
    handleFlightSearch({
      target: {
        value,
        name,
      },
    });
  };

  const handleMultiCityChange = (data, name, index) => {
    const multiCitySearch = [...search.flightsearchrequest.multiCitySearch];
    const errorList = errors.multiCity || [];
    if (name === 'origin') {
      multiCitySearch[index].origin = data.value;
      multiCitySearch[index].selectedOrigin = data;
      errorList[index].origin = undefined;
    } else if (name === 'destination') {
      multiCitySearch[index].destination = data.value;
      multiCitySearch[index].selectedDestination = data;
      errorList[index].destination = undefined;
    } else if (name === 'onwarddate') {
      multiCitySearch[index].onwarddate = getNewDate(data);
      for (let i = 0; i < multiCitySearch.length; i++) {
        if (i > index) {
          multiCitySearch[i].onwarddate = '';
        }
      }
      errorList[index].onwarddate = undefined;
    }
    setSearch({
      ...search,
      flightsearchrequest: { ...search.flightsearchrequest, multiCitySearch },
    });
    setErrors({ ...errors, multiCity: errorList });
  };

  const onRemoveMultiCityRow = (index) => {
    const multiCitySearch = [...search.flightsearchrequest.multiCitySearch];
    const errorList = errors.multiCity || [];
    multiCitySearch.splice(index, 1);
    errorList.splice(index, 1);
    setSearch({
      ...search,
      flightsearchrequest: { ...search.flightsearchrequest, multiCitySearch },
    });
    setErrors({ ...errors, multiCity: errorList });
  };
  const onAddMultiCityRow = () => {
    const multiCitySearch = [...search.flightsearchrequest.multiCitySearch];
    if (multiCitySearch.length === 5) {
      setAlert({
        title: 'Multi City Search',
        description: 'More than 5 flights are not allowed',
        variant: 'error',
      });
      return;
    }
    const errorList = errors.multiCity || [];
    let obj = {};
    if (
      multiCitySearch[multiCitySearch.length - 1].destination !== '' &&
      multiCitySearch[multiCitySearch.length - 1].destination !== null &&
      multiCitySearch[multiCitySearch.length - 1].destination !== undefined
    ) {
      obj = {
        origin: multiCitySearch[multiCitySearch.length - 1].destination,
        destination: '',
        onwarddate: '',
        selectedOrigin:
          multiCitySearch[multiCitySearch.length - 1].selectedDestination,
      };
    } else {
      obj = {
        origin: '',
        destination: '',
        onwarddate: '',
      };
    }
    multiCitySearch.push(obj);
    errorList.push({ onwarddate: '', origin: '', destination: '' });
    setSearch({
      ...search,
      flightsearchrequest: { ...search.flightsearchrequest, multiCitySearch },
    });
    setErrors({ ...errors, multiCity: errorList });
  };

  const handleNonStopSelect = () => {
    const isNonStop =
      search.flightsearchrequest.nonstopsearch === 'false' ? 'true' : 'false';
    handleUpdateSearchState('nonstopsearch', isNonStop);
  };

  return (
    <div className="modify-search-page">
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <div className="modify-search-page_container">
        <div className="modify-search-page_search">
          <div className="modify-search-page_search_container p-1">
            <div className="searchtype-container d-flex align-items-center mb-1">
              <AppRadioInput
                id="OneWay"
                name="journeytype"
                labelText={formattedMessage('oneway_btn')}
                value="OneWay"
                onChange={handleChange}
                checked={search.flightsearchrequest.journeytype === 'OneWay'}
              />
              <AppRadioInput
                id="RoundTrip"
                name="journeytype"
                labelText={formattedMessage('roundtrip_btn')}
                value="RoundTrip"
                onChange={handleChange}
                checked={search.flightsearchrequest.journeytype === 'RoundTrip'}
              />
              {appConfig?.hasMultiCity && (
                <AppRadioInput
                  labelText="Multi city"
                  id="MultiCity"
                  name="journeytype"
                  value="MultiCity"
                  onChange={handleChange}
                  checked={
                    search.flightsearchrequest.journeytype === 'MultiCity'
                  }
                />
              )}
            </div>
            <Row className="modify-search-page_search_request spacing-8">
              {search.flightsearchrequest.journeytype !== 'MultiCity' ? (
                <Col lg={8} md={8} sm={8} xs={12}>
                  <Row className="spacing-8">
                    <Col
                      lg={4}
                      md={4}
                      sm={4}
                      xs={6}
                      className="position-relative"
                    >
                      <AppAsyncSelect
                        name="origin"
                        height="54px"
                        placeholder=""
                        components={{ Option: AirportOption }}
                        selectedValue={originAirportRef.current}
                        loadOptionsFn={loadAirportSuggestions}
                        defaultOptions={defaultAirportsList}
                        onSelect={handleAirportSelect}
                        label={formattedMessage('from')}
                        menuWidth="320px !important"
                        bgColor="#FFFFFF14"
                        padding="8px 14px"
                        color="#fff"
                        className="border-right"
                        selectedTab="flight"
                      />
                      <small className="validation-error">
                        {errors.origin && errors.origin}
                      </small>

                      <div className="d-flex justify-content-center origin-swap">
                        <button
                          onClick={handleSwap}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <MdOutlineSwapHoriz style={{ color: '#e0621a' }} />
                        </button>
                      </div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={6}>
                      <AppAsyncSelect
                        placeholder=""
                        name="destination"
                        height="54px"
                        components={{ Option: AirportOption }}
                        selectedValue={destinationAirportRef.current}
                        loadOptionsFn={loadAirportSuggestions}
                        defaultOptions={defaultAirportsList}
                        onSelect={handleAirportSelect}
                        label={formattedMessage('to')}
                        menuWidth="320px !important"
                        bgColor="#FFFFFF14"
                        padding="8px 14px"
                        color="#fff"
                        className="border-left"
                        menuStartFromRight={isMobileWidth()}
                        selectedTab="flight"
                      />
                      <small className="validation-error">
                        {errors.destination && errors.destination}
                      </small>
                    </Col>
                    <Col lg={4} md={4} sm={6} xs={12}>
                      <Row className="spacing-8">
                        <Col lg={6} md={6} sm={6} xs={6}>
                          <AppDatePicker
                            customClassName="app-modify-datepicker"
                            label="Depart"
                            labelClassName="landing-datepicker-label"
                            minDate={getNewDate(TODAY_DATE)}
                            monthsShown={isMobileWidth() ? 12 : 2}
                            dateFormat="dd MMM yyyy"
                            selectedDate={search.flightsearchrequest.onwarddate}
                            onChange={(date) =>
                              handleDateChange(date, 'onwarddate')
                            }
                            customMobileClass="border-right"
                          />
                          <small className="validation-error">
                            {errors.onwarddate && errors.onwarddate}
                          </small>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={6}>
                          <AppDatePicker
                            customClassName="app-modify-datepicker border-left"
                            label="Return"
                            labelClassName="landing-datepicker-label"
                            placeholder="--"
                            minDate={
                              search.flightsearchrequest.onwarddate === ''
                                ? getNewDate(TODAY_DATE)
                                : search.flightsearchrequest.onwarddate
                            }
                            monthsShown={isMobileWidth() ? 12 : 1}
                            dateFormat="dd MMM yyyy"
                            selectedDate={search.flightsearchrequest.returndate}
                            onChange={(date) =>
                              handleDateChange(date, 'returndate')
                            }
                            customMobileClass="border-left"
                          />
                          <small className="validation-error">
                            {errors.returndate && errors.returndate}
                            {errors.onwaredDateAfterReturnDate &&
                              errors.onwaredDateAfterReturnDate}
                          </small>
                          {search.flightsearchrequest.returndate !== '' && (
                            <div
                              className="modify-clear-return-date"
                              onClick={handleClearReturnDate}
                            >
                              X
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              ) : (
                <Col lg={8} md={8} sm={8} xs={12}>
                  {search.flightsearchrequest.multiCitySearch.map(
                    (d, index) => (
                      <Row key={index} className="spacing-8 mb-1">
                        <Col lg={4} md={4} sm={4} xs={6}>
                          <AppAsyncSelect
                            placeholder=""
                            name="origin"
                            components={{ Option: AirportOption }}
                            selectedValue={d.selectedOrigin}
                            loadOptionsFn={loadAirportSuggestions}
                            defaultOptions={defaultAirportsList}
                            onSelect={(airport, name) =>
                              handleMultiCityChange(airport, name, index)
                            }
                            label={formattedMessage('depart_from')}
                            menuWidth="320px !important"
                            bgColor="#FFFFFF14"
                            padding="8px 14px"
                            color="#fff"
                            className="border-right"
                            height="54px"
                            selectedTab="flight"
                          />
                          <small className="validation-error">
                            {errors.multiCity[index]?.origin &&
                              errors.multiCity[index].origin}
                          </small>
                        </Col>
                        <Col lg={4} md={4} sm={4} xs={6}>
                          <AppAsyncSelect
                            placeholder=""
                            name="destination"
                            components={{ Option: AirportOption }}
                            selectedValue={d.selectedDestination}
                            loadOptionsFn={loadAirportSuggestions}
                            defaultOptions={defaultAirportsList}
                            onSelect={(airport, name) =>
                              handleMultiCityChange(airport, name, index)
                            }
                            label={formattedMessage('going_to')}
                            menuWidth="320px !important"
                            bgColor="#FFFFFF14"
                            padding="8px 14px"
                            color="#fff"
                            className="border-right"
                            height="54px"
                            selectedTab="flight"
                          />
                          <small className="validation-error">
                            {errors.multiCity[index]?.destination &&
                              errors.multiCity[index].destination}
                          </small>
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <Row>
                            <Col lg={6} md={6} sm={12} xs={12}>
                              <AppDatePicker
                                customClassName="app-modify-datepicker border-left"
                                label={formattedMessage('depart_date')}
                                labelClassName="landing-datepicker-label"
                                minDate={
                                  index === 0
                                    ? getNewDate(TODAY_DATE)
                                    : search.flightsearchrequest
                                        .multiCitySearch[index - 1].onwarddate
                                }
                                monthsShown={isMobileWidth() ? 12 : 2}
                                dateFormat="dd MMM yy"
                                selectedDate={d.onwarddate}
                                onChange={(date) =>
                                  handleMultiCityChange(
                                    date,
                                    'onwarddate',
                                    index,
                                  )
                                }
                                customMobileClass="border-right"
                              />
                              <small className="validation-error">
                                {errors.multiCity[index]?.onwarddate &&
                                  errors.multiCity[index].onwarddate}
                              </small>
                            </Col>
                            <Col
                              lg={6}
                              md={6}
                              sm={6}
                              xs={6}
                              className="d-flex gap-2 fw-600 align-items-center"
                            >
                              {search.flightsearchrequest.multiCitySearch
                                .length > 2 &&
                                [0, 1].indexOf(index) === -1 && (
                                  <AppButton
                                    btnText="Remove"
                                    variant="outlined"
                                    onClick={() => onRemoveMultiCityRow(index)}
                                  />
                                  // <AppIconButton
                                  //   onClick={() => onRemoveMultiCityRow(index)}
                                  //   variant="white"
                                  //   className="flight-search-multicity-action-btn white-color"
                                  // >
                                  //   <MdOutlineRemoveCircleOutline />
                                  // </AppIconButton>
                                )}
                              {index === 0 && (
                                <AppButton
                                  btnText="Add City"
                                  className="fs-12"
                                  variant="outlined-secondary"
                                  onClick={onAddMultiCityRow}
                                />
                                // <AppIconButton
                                //   variant="white"
                                //   className="flight-search-multicity-action-btn white-color"

                                // >
                                //   <MdAddCircleOutline />
                                // </AppIconButton>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    ),
                  )}
                </Col>
              )}
              <Col lg={2} md={2} sm={4} xs={12}>
                <div
                  className="travellers-class d-flex justify-content-between align-items-center"
                  ref={passengersOverlayTarget}
                  onClick={() => setOpenPassengers(!openPassengers)}
                >
                  <div className="d-flex flex-column">
                    <span className="fs-10" style={{ color: '#e3ecf8' }}>
                      <span className="fs-12 travellers-class_label">
                        <FormattedMessage id="travellers" />,{' '}
                        <FormattedMessage id="class" />
                      </span>
                    </span>
                    <span className="travellers-class_text">
                      {parseInt(search.flightsearchrequest.numadults, 10)}A,
                      {search.flightsearchrequest.numchildren > 0 &&
                        `${parseInt(
                          search.flightsearchrequest.numchildren,
                          10,
                        )}C,`}
                      {search.flightsearchrequest.numinfants > 0 &&
                        `${parseInt(
                          search.flightsearchrequest.numinfants,
                          10,
                        )}I,`}
                      {formattedMessage(
                        PREF_CLASS_DICT[search.flightsearchrequest.prefclass],
                      )}
                    </span>
                  </div>
                </div>
                <Overlay
                  rootClose
                  target={passengersOverlayTarget.current}
                  show={openPassengers}
                  placement="bottom"
                  onHide={() => setOpenPassengers(false)}
                >
                  {({
                    placement,
                    arrowProps,
                    show: _show,
                    popper,
                    ...props
                  }) => (
                    <div
                      {...props}
                      style={{
                        position: 'absolute',
                        padding: '1rem',
                        borderRadius: '8px',
                        maxWidth: isMobileView.current ? '92%' : '320px',
                        backgroundColor: '#b0d3f6',
                        zIndex: 9999,
                        ...props.style,
                      }}
                      className="travellers-class_overlay"
                    >
                      <div className="d-flex flex-column">
                        <span className="fs-12 fw-600">
                          {' '}
                          <FormattedMessage id="adults12" />
                        </span>
                        <div className="my-1">
                          <ul className="num-pax_list d-flex">
                            {NUMPAX_DICT.map(
                              (pax) =>
                                pax !== '0' && (
                                  <li
                                    key={pax}
                                    className={`${
                                      search.flightsearchrequest.numadults ===
                                      pax
                                        ? 'selected'
                                        : ''
                                    } num-pax_list_item`}
                                    onClick={() =>
                                      handleUpdateSearchState('numadults', pax)
                                    }
                                  >
                                    {pax}
                                  </li>
                                ),
                            )}
                          </ul>
                        </div>
                      </div>
                      <div className="d-flex flex-column">
                        <span className="fs-12 fw-600">
                          <FormattedMessage id="children_2_12" />
                        </span>
                        <div className="my-1">
                          <ul className="num-pax_list d-flex">
                            {NUMPAX_DICT.map((pax) => (
                              <li
                                key={pax}
                                className={`${
                                  search.flightsearchrequest.numchildren === pax
                                    ? 'selected'
                                    : ''
                                } num-pax_list_item`}
                                onClick={() =>
                                  handleUpdateSearchState('numchildren', pax)
                                }
                              >
                                {pax}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="d-flex flex-column">
                        <span className="fs-12 fw-600">
                          <FormattedMessage id="infant_2" />
                        </span>
                        <div className="my-1">
                          <ul className="num-pax_list d-flex">
                            {NUMPAX_DICT.map((pax) => (
                              <li
                                key={pax}
                                className={`${
                                  search.flightsearchrequest.numinfants === pax
                                    ? 'selected'
                                    : ''
                                } num-pax_list_item`}
                                onClick={() =>
                                  handleUpdateSearchState('numinfants', pax)
                                }
                              >
                                {pax}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="mb-2">
                        <select
                          name="prefclass"
                          id="prefclass"
                          style={{ borderRadius: '3px' }}
                          value={search.flightsearchrequest.prefclass}
                          onChange={handleChange}
                          className="fs-14 fs-600 w-100 py-1"
                        >
                          <option value="Y">
                            <FormattedMessage id="economy" />
                          </option>
                          <option value="W">
                            <FormattedMessage id="premium_economy" />
                          </option>
                          <option value="C">
                            <FormattedMessage id="business" />
                          </option>
                          <option value="F">
                            <FormattedMessage id="first_class" />
                          </option>
                        </select>
                      </div>
                      <div className="text-center">
                        <AppButton
                          btnText={<FormattedMessage id="done_btn" />}
                          onClick={handlePassengersSelection}
                          variant="secondary"
                          className="px-4"
                        />
                      </div>
                    </div>
                  )}
                </Overlay>
              </Col>
              <Col lg={2} md={2} sm={4} xs={12} className="d-flex">
                <div className="d-flex justify-content-center gap-1 flex-1 ps-sm-5 ps-0">
                  <AppButton
                    btnText="Search"
                    variant="primary"
                    onClick={handleFlightSearch}
                    className="flex-1"
                  />
                </div>
              </Col>
            </Row>
            <Row className="spacing-0 mt-2">
              <Col
                lg={10}
                md={10}
                sm={12}
                xs={12}
                className="d-flex flex-column overflow-auto"
              >
                <div className="searchtype-container d-flex align-items-center">
                  <span className="fs-12 white-color">Fare Type: </span>
                  <AppRadioInput
                    id="normal"
                    name="searchtype"
                    labelText={<FormattedMessage id="regular" />}
                    value="normal"
                    onChange={handleSearchTypeChange}
                    checked={search.flightsearchrequest.searchtype === 'normal'}
                  />
                  <AppRadioInput
                    id="student"
                    name="searchtype"
                    labelText={<FormattedMessage id="student_fare" />}
                    value="student"
                    onChange={handleSearchTypeChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'student'
                    }
                  />
                  <AppRadioInput
                    id="seniorcitizen"
                    name="searchtype"
                    labelText={<FormattedMessage id="senior_citizen" />}
                    value="seniorcitizen"
                    onChange={handleSearchTypeChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'seniorcitizen'
                    }
                  />
                  <AppRadioInput
                    id="seriesfares"
                    name="searchtype"
                    labelText="Series Fare"
                    value="seriesfares"
                    onChange={handleSearchTypeChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'seriesfares'
                    }
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}
ModifySearch.defaultProps = {
  previousSearchRequest: undefined,
  onModifySearch: () => {},
  isModifySearch: false,
};

ModifySearch.propTypes = {
  previousSearchRequest: PropTypes.object,
  onModifySearch: PropTypes.func,
  isModifySearch: PropTypes.bool,
};

export default ModifySearch;
